import {isAllRooms, RoomsFilter} from "../constants/rcn_rooms_filter";

interface RoomPrices<T extends number | null> {
    avg_price_m2: T;
    avg_price_m2_studio: T;
    avg_price_m2_2_rooms: T;
    avg_price_m2_3_rooms: T;
    avg_price_m2_4_plus_rooms: T;
}

// Generic over T so district data (room segments nullable - BigData returns null for a segment with too few
// transactions in that district/month) and city data (always present) each keep their own return nullability.
export const getAvgPriceM2ForRooms = <T extends number | null>(record: RoomPrices<T>, rooms: RoomsFilter): T => {
    if (isAllRooms(rooms)) {
        return record.avg_price_m2;
    }

    switch (rooms) {
        case 1:
            return record.avg_price_m2_studio;
        case 2:
            return record.avg_price_m2_2_rooms;
        case 3:
            return record.avg_price_m2_3_rooms;
        default:
            return record.avg_price_m2_4_plus_rooms;
    }
};
import {isAllRooms, RoomsFilter} from "../constants/rcn_rooms_filter";

interface RoomPrices<T extends number | null> {
    avg_price_m2: T;
    avg_price_m2_studio: T;
    avg_price_m2_2_rooms: T;
    avg_price_m2_3_rooms: T;
    avg_price_m2_4_plus_rooms: T;
}

// Generic over T so district data (room segments nullable - BigData returns null for a segment with too few
// transactions in that district/month) and city data (always present) each keep their own return nullability.
export const getAvgPriceM2ForRooms = <T extends number | null>(record: RoomPrices<T>, rooms: RoomsFilter): T => {
    if (isAllRooms(rooms)) {
        return record.avg_price_m2;
    }

    switch (rooms) {
        case 1:
            return record.avg_price_m2_studio;
        case 2:
            return record.avg_price_m2_2_rooms;
        case 3:
            return record.avg_price_m2_3_rooms;
        default:
            return record.avg_price_m2_4_plus_rooms;
    }
};
